module.exports = __webpack_public_path__ + "static/img/ent-79.4e67d50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-79.jpg
// module id = Sbhc
// module chunks = 51